import img0 from './assets/img/article/1 year.jpg';
import ishat from './assets/img/article/ishat.png'; 
import img1 from './assets/img/article/2.jpg';

export const contentMenu = [
    {
        title: '1 year of success',
        text: "Cheers to a year of being great together as a prominent team and a loving family. With your support and the team's hard work, Upward Bangladesh has crossed its 1 year of success. Let's look behind to see what we had done for celebrating this triumph. After founding on 21st May 2020 we got over 100+ applicants and among them, we are now a family of 40 members.",
        link: 'https://www.facebook.com/UpwardBD/posts/308056790915046',
        img: img0
    },
    {
        title: 'Save ISHAT',
        text: "নয় বছরের শিশু ইশাত মরণব্যাধি ক্যান্সারে আক্রান্ত হয়ে বেঁচে থাকার যুদ্ধে লড়াই করছে। এই লড়াইয়ে সবাইকেই খুব প্রয়োজন তার। শিশুটিকে বাঁচিয়ে তুলতে আমাদের সামান্য সহযোগিতাও অনেক বড় অবদান হতে পারে। ইশাত কে সুন্দর জীবন দিতে আমাদের যতটুকু সম্ভব - সাহায্য করি।",
        link: 'https://www.facebook.com/UpwardBD/posts/307783354275723',
        img: ishat
    },
    {
        title: 'Ecosystem Restoration',
        text: 'সময়ের স্রোতে এগিয়ে চলা বিশ্বে প্রযুক্তির কল্যাণে আমরা যত কাছাকাছি আসছি, সবুজে ঘেরা নির্মল প্রকৃতি যেন ততই দূরে সরে যাচ্ছে আমাদের কাছ থেকে। আজ, ৫ই জুন, ৪৯ তম বিশ্ব পরিবেশ দিবস। ১৯৭২ সালে স্টকহোমে পালিত এই দিনটির স্মরণে গত প্রায় অর্ধ শতাব্দী ধরে পালিত হয়ে আসছে এই দিবস। এবারের পরিবেশ দিবসের প্রতিপাদ্য, ‘ Ecosystem Restoration’ যার বাংলা ভাবানুবাদ ‘প্রতিবেশ সংরক্ষণ ও পুনরুদ্ধার’।',
        link: 'https://www.facebook.com/UpwardBD/posts/317607989959926',
        img: img1
    },
]